module.exports = __webpack_public_path__ + "img/annual_certificate_1.08653def.svg";